import { useEffect, useState } from "react"
import { MdOutlineContentPaste, MdSearch } from "react-icons/md"
import { Button, ButtonLoader } from "../../components/Button"
import { CardModal } from "../../components/Card"
import { Input } from "../../components/Form"
import ItemCardGrid from "../../components/GridView"
import { ListView } from "../../components/ListView"
import { LoadingWithLabel } from "../../components/Loading"
import { ModalBody, ModalDouble, ModalHeader, ModalPanel } from "../../components/Modal"
import "./styles.scss"
import { isMobile } from "react-device-detect"

const MessageNewsScreen = ({
  open,
  openModalContent,
  onSearchTags,
  selectedPosts,
  setOpen,
  filterPosts,
  filteredPosts,
  changeOptions,
  changeCheckAll,
  removeSelectedContent,
  sendMessage,
  sendContentByHeap,
  saving,
  loading,
  posts,
  hasDefaultPosts,
}) => {
  return (

    <>
      {open && (
        <ModalPanel modalIsOpen={open}>
          {isMobile ? (
            <div className="form-header">
              <div style={{ display: "flex", gap: "10px" }} onClick={() => setOpen(false)}>
                <button className="button-back">
                  <i className="fi fi-sr-arrow-small-left" />
                </button>
                <div className="title">Enviar conteúdo</div>
              </div>
            </div>
          ) : (
            <ModalHeader closeModal={() => setOpen(false)} title="Enviar Conteúdo" />
          )}
          {isMobile ? (
            <ModalBody
              styles={{ display: "flex", flexDirection: "column", padding: 0 }}
              className="modal-send-content">
              <div className="message-news-input">
                {isMobile ? (
                  <>
                    <Input
                      placeholder={"Pesquise pelo nome do conteúdo"}
                      onChange={onSearchTags}
                      hasIcon={<MdSearch size={16} />}
                      hasFocus={false}
                    />
                    <div style={{ fontSize: "20px", marginTop: "10px" }}>
                      Selecione um ou mais conteúdos
                    </div>
                  </>
                ) : (
                  <div>
                    <Input
                      placeholder={"Digite aqui o conteúdo que deseja buscar"}
                      onChange={onSearchTags}
                      hasIcon={<MdSearch size={16} />}
                      hasFocus={false}
                    />
                  </div>
                )}
              </div>
              {loading && !filterPosts?.length ? (
                <LoadingWithLabel
                  labelLoading="Aguarde, estamos buscando os conteúdos"
                  colorSpinner="primary"
                />
              ) : (
                <ListView
                  data={filterPosts.map(({ id, title }) => ({
                    value: id,
                    label: title,
                    checkbox: true,
                  }))}
                  checked={selectedPosts}
                  changeCheckAll={changeCheckAll}
                  changeOptions={changeOptions}
                  height={400}
                  checkedDisable={hasDefaultPosts ? true : false}
                />
              )}
              <div className="button-enviar">
                {!openModalContent ? (
                  <ButtonLoader
                    label={selectedPosts?.length > 0 ? `Enviar (${selectedPosts.length})` : "Enviar"}
                    handleClick={() => (hasDefaultPosts ? sendContentByHeap() : sendMessage())}
                    color="green"
                    loading={saving}
                    className={"button-green"}
                    messageProcess="Enviando Conteúdo"
                  />
                ) : (
                  <Button
                    label="Confirmar"
                    handleClick={() => setOpen(false)}
                    color="orange"
                    className={"w-20 flex-end"}
                  />
                )}
              </div>
            </ModalBody>
          ) : (
            <ModalBody
              styles={{ width: "1100px", display: "flex", flexDirection: "row", padding: 0 }}
              className="modal-send-content">
              <ModalDouble title={"Selecione um conteúdo ou mais"} position={"left"} noPadding>
                <div className="message-news-input">
                  <Input
                    placeholder={"Digite aqui o conteúdo que deseja buscar"}
                    onChange={onSearchTags}
                    hasIcon={<MdSearch size={16} />}
                    hasFocus={false}
                  />
                </div>
                {loading && !filterPosts?.length ? (
                  <LoadingWithLabel
                    labelLoading="Aguarde, estamos buscando os conteúdos"
                    colorSpinner="primary"
                  />
                ) : (
                  <ListView
                    data={filterPosts.map(({ id, title }) => ({
                      value: id,
                      label: title,
                      checkbox: true,
                    }))}
                    checked={selectedPosts}
                    changeCheckAll={changeCheckAll}
                    changeOptions={changeOptions}
                    height={330}
                    checkedDisable={hasDefaultPosts ? true : false}
                  />
                )}
              </ModalDouble>
              <ModalDouble
                title={`Conteúdos selecionados${selectedPosts.length > 0 ? " " + selectedPosts.length : ""
                  }`}
                noBorderTitle
                position={"right"}
                className="secondary content-header-mobile">
                <div className="grid-content-news-send">
                  <div className="content-grid content-grid-mobile">
                    <ItemCardGrid
                      handleClick={removeSelectedContent}
                      items={filteredPosts() || []}
                      hasRemoveIcon={!hasDefaultPosts}
                    />
                  </div>
                  <div className="grid-content-news-send-button">
                    {!openModalContent ? (
                      <ButtonLoader
                        label="Enviar"
                        handleClick={() => (hasDefaultPosts ? sendContentByHeap() : sendMessage())}
                        color="orange"
                        loading={saving}
                        className={"w-20 flex-end"}
                        messageProcess="Enviando Conteúdo"
                      />
                    ) : (
                      <Button
                        label="Confirmar"
                        handleClick={() => setOpen(false)}
                        color="orange"
                        className={"w-20 flex-end"}
                      />
                    )}
                  </div>
                </div>
              </ModalDouble>
            </ModalBody>
          )}
        </ModalPanel>
      )}
    </>
  )
}

export default MessageNewsScreen
